import { TValueOfStringRecord } from '@interfaces/common/genericWithModifying';

export const EExportActionsTypes = {
	all: 'all',
	allFiltered: 'allFiltered',
	currentPage: 'currentPage',
	selected: 'selected',
} as const;

export type TExportActionsTypes = TValueOfStringRecord<typeof EExportActionsTypes>
